import VueRouter from 'vue-router';

// Vue Templates
import Home from '@/views/Home.vue';
import Preprod from '@/views/Preprod.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/preprod',
        name: 'Preprod',
        component: Preprod,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
